<div class="destination-settings-panel">
  <p *ngIf="state === 'loading'" class="destination-settings-panel__status">
    Loading destination settings…
  </p>
  <p *ngIf="state === 'error'" class="destination-settings-panel__status destination-settings-panel__status--error">
    {{ errorMessage || 'Could not load destination settings.' }}
  </p>
  <ng-container *ngIf="isReady">
    <evrideo-destination-youtube-settings
      *ngIf="isYouTube && videoCategories"
      [catalog]="videoCategories"
      [platformData]="platformData"
      [readonly]="readonly"
      [appearance]="appearance"
      (platformDataChange)="onPlatformDataChange($event)"
    ></evrideo-destination-youtube-settings>
    <evrideo-destination-platform-settings
      *ngIf="!isYouTube"
      [platformId]="platform.platformId"
      [platformData]="platformData"
      [readonly]="readonly"
      [appearance]="appearance"
      (platformDataChange)="onPlatformDataChange($event)"
    ></evrideo-destination-platform-settings>

    <div *ngIf="canSave" class="destination-settings-panel__save-row">
      <div
        class="button apply"
        [class.disabled]="isSaving"
        (click)="onSaveClick()"
      >
        {{ isSaving ? 'Saving…' : 'Save' }}
      </div>
    </div>
  </ng-container>
</div>
